import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerServiceContext } from './CustomerServiceContext';
import { en, fr } from './i18n';
import Link from './Link';

const ArticleBodyHelp = () => {
    const { i18n, t } = useTranslation('customer-service');
    i18n.addResourceBundle('en', 'customer-service', en, true, true);
    i18n.addResourceBundle('fr', 'customer-service', fr, true, true);

    const ctx = useContext(CustomerServiceContext);

    return (
        <p className="customer-service-faq__article__body__help">
            {t('needFurtherAssistance')}{' '}
            <Link
                href="/pages/customer-service/contact-info"
                onClick={() => {
                    ctx.setView('article');
                    ctx.setContact('contact-info');
                    ctx.setUrlName('contact-info');
                }}
                className="customer-service-faq__article__body__help__link"
            >
                {t('contactUs')}
            </Link>
        </p>
    );
};

export default ArticleBodyHelp;
